export const TENANT_ID = 'trillium';
export const APP_ID = 'trillium-web';

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: 'demoHomePage$root', // TODO: Replace with Trillium-specific masonry home root node id once the Masonry container is published.
  ROOT_NODE_ID_SUPPORT_PAGE: 'support$root',
};
